const placeholders = {
    VEHICLES_SEARCH: 'Search by make, model, license plate or VIN',
    CUSTOMER_SEARCH: 'Search by name, email or phone number',
    INVENTORY_SEARCH: "Search your shop's inventory",
    SUPPLIER_SEARCH: "Search by supplier's business name, phone or email ",
    RO_ARCHIVE_SEARCH: 'Search by RO#, title, customer name, vehice VIN, or license plate',
    VIN_LOOKUP_LABEL: 'Lookup by VIN:',
    VEHICLE_QUICK_HISTORY: 'Quick History',
};

export default placeholders;
